<template>
  <div>
    <div class="columns is-vcentered is-gapless has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        &nbsp;
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey has-text-normal"
          @click="newRdv"
        >
          <span class="icon is-small"><i class="fal fa-calendar-plus"></i></span>
          <span>Nouveau rendez-vous</span>
        </a>
      </div>
    </div>
    <div>
      <div class="column is-paddingless is-12 is-border has-bg-white" v-if="rdvList && rdvList.length">
        <div v-for="(e, idx) in rdvList" v-if="e && e.event" :key="e.event.pk">
          <div class="column has-bg-light is-border-bottom is-size-5 has-text-centered is-padding-small"
              :class="{'is-border-top' : idx !== 0}" v-if="e.showDayLabel">
            <strong>{{ e.date | dtFormat('dddd') | cap }} {{ e.date | dtFormat('DD')}} {{ e.date | dtFormat('MMMM') |
              cap}}</strong>
          </div>
          <div class="bulma-calendar">
            <div class="calendar is-large day-view has-bg-white is-borderless">
              <div class="calendar-container">
                <div class="day-events is-border-bottom">
                  <calendar-rdv-item :key="e.eventpk"
                                      :is-open="currentEvent && currentEvent.pk === e.event.pk"
                                      :event="e.event"
                                      type="RDV"
                                      :rdvs="rdvs"
                                      :selected-event="selectedEvent"
                                      @selectedEvent="val => selectedEvent = val"
                                      @openEvent="setCurrentEvent"
                                      @addEvent="$emit('reloadRdvs')"
                                      @delete-event="deleteEvent"
                                      @updateRdv="val => $emit('updateRdv', val)"
                  ></calendar-rdv-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { orderBy } from 'lodash'
  import CalendarRdvItem from '../../calendar/CalendarRdvItem'
  import { GoogleMx } from '@/mixins'

  export default {
    name: 'ContactRdvList',
    data () {
      return {
        currentEvent: null,
        selectedEvent: null
      }
    },
    components: { CalendarRdvItem },
    mixins: [ GoogleMx ],
    props: {
      sourceRdvs: {
        type: Array,
        required: true
      },
      sourceContact: {
        type: Object,
        required: true
      }
    },
    computed: {
      rdvs () {
        return this.sourceRdvs
      },
      rdvList () {
        let rdvList = []
        if (this.listedEvents && this.listedEvents.length) {
          return this.listedEvents.map(x => {
            let date = moment(x.date).format('DD/MM/YYYY')
            if (rdvList.includes(date) === false) {
              this.$set(x, 'showDayLabel', true)
              rdvList.push(date)
            }
            return x
          })
        }
      },
      listedEvents () {
        let listedEvents = []
        if (this.rdvs && Array.isArray(this.rdvs) && this.rdvs) {
          this.rdvs.forEach(x => {
            let wrapper = {
              event: Object.assign({}, x),
              date: x.date,
              showDayLabel: false
            }
            listedEvents.push(wrapper)
          })
        }
        return orderBy(listedEvents, x => {
          return moment(x.date)
        }, 'desc')
      }
    },
    filters: {
      address (value) {
        if (!value) return '-'
        return value.zip_code && value.city ? `${value.zip_code} ${value.city}` : '-'
      }
    },
    methods: {
      newRdv () {
        let params = {
          contact: this.sourceContact.pk
        }
        this.$router.push({name: 'CalendarCreate', query: params})
      },
      setCurrentEvent (event) {
        this.currentEvent = event
      },
      deleteEvent (e) {
        this.$emit('reloadRdvs')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactRdvList.vue